/**
 * Represents a DetailsAnchor component that generates an HTML anchor element with a URL and an ID.
 * @class
 */
export default class DetailsAnchor {
  /**
   * Creates a new instance of DetailsAnchor.
   * @constructor
   * @param {string} url - The URL to be used in the anchor element.
   */
  constructor() {
    this.anchorId = 'detailPageAnchor';
  }

  /**
   * Sets the binding required for the anchor details.
   */
  bindEvents() {
    this.getAnchor().addEventListener('click', this.onClickEvent.bind(this));
  }

  /**
   * Dispatches a custom event named 'detailAnchorClicked' with details of the lisitng clicked
   */
  onClickEvent() {
    document.body.dispatchEvent(
      new CustomEvent('detailAnchorClicked', {
        detail: {
          listingId: this.listingId,
          listingType: this.listingType,
        },
      })
    );
  }

  /**
   * Sets the URL for the details anchor.
   * @param {string} url - The URL to set.
   */
  setUrl(url) {
    this.url = url;
  }

  /**
   * Sets the listing id for the details anchor.
   * @param {number} id - The id of the listing.
   */
  setListingId(id) {
    this.listingId = id;
  }

  /**
   * Sets the listing type for the details anchor.
   * @param {number} id - The type of the listing.
   */
  setListingType(type) {
    this.listingType = type;
  }

  /**
   * Gets the HTML anchor element with the specified ID.
   * @returns {HTMLElement} The HTML anchor element.
   */
  getAnchor() {
    return document.getElementById(this.anchorId);
  }

  /**
   * Gets the HTML code for the anchor element.
   * @returns {string} The HTML code for the anchor element.
   */
  getHtml() {
    return this.url
      ? `
      <a data-qa="more-details" id="${this.anchorId}" href="${this.url}" target="_blank"class="btn btn--blue btn--48-lg">
          More Details
      </a>`
      : ``;
  }
}
